import { httpClient } from './http';
import { API_ENDPOINTS } from '../config/api';

export interface RecommendationRecord {
  id: string | number;
  restaurantId: string;
  recommendations: any; // jsonb
  createdAt: string;
  updatedAt: string;
}

export const recommendationsService = {
  getByRestaurant: async (restaurantId: string, params?: { date?: string }): Promise<RecommendationRecord | null> => {
    try {
      const res = await httpClient.get<RecommendationRecord>(
        API_ENDPOINTS.RECOMMENDATIONS_BY_RESTAURANT(restaurantId),
        { date: params?.date },
        'authenticated',
      );
      return res || null;
    } catch (err) {
      console.error('❌ Error obteniendo recomendaciones:', err);
      return null;
    }
  },
};


